// extracted by mini-css-extract-plugin
export default {"savetime":"styles_savetime__Mb1KA","savetime__row":"styles_savetime__row__cPVfr"};